import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';
import convertToRupees from '../../../../../utilities/convertToRupees';


const TaxDetails = ({ data }) => {
    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Table>
                        <tbody>
                            <tr>
                                <td>TAX Type</td>
                                {/* <td>{data?.product?.tax_type}</td> */}
                                <td>{"GST"}</td>
                            </tr>
                            {/* <tr>
                                <td>{`${data?.product?.tax_type} (18%)`}</td>
                                <td>{data?.product?.tax_amount}</td>
                            </tr> */}
                            {data?.user?.state?.toLowerCase() == data?.dealer?.state?.toLowerCase() ? (
                            <>
                            <tr>
                                <td>CGST (9%)</td>
                                <td>{ data?.policy?.cgst_amount ? convertToRupees(data?.policy?.cgst_amount) : 'NA' }</td>
                            </tr>
                            <tr>
                                <td>SGST (9%)</td>
                                <td>{ data?.policy?.sgst_amount ? convertToRupees(data?.policy?.sgst_amount ) : 'NA'}</td>
                            </tr>
                            </>
                            ) : (
<tr>
                                <td>IGST (18%)</td>
                                <td>{data?.policy?.igst_amount? convertToRupees(data?.policy?.igst_amount) : 'NA'}</td>
                            </tr>
                            ) }
                            
                            
                            <tr>
                                <th>Invoice Amount</th>
                                {/* <td>{ data?.policy?.net_payable_amount ? convertToRupees(data?.policy?.net_payable_amount + data?.policy?.upfront_dc + data?.policy?.upfront_dc_tax, true) : 'NA'}</td> */}
                                <td>{convertToRupees(data?.product?.selling_price, true)|| "-"}</td>
                            
                            </tr>
                        </tbody>
                        <tfoot>
                        {/* <tr>
                                <th>Total</th>
                                <td>{ data?.policy?.net_payable_amount ? convertToRupees(data?.policy?.net_payable_amount) : 'NA'}</td>
                            </tr> */}
                        </tfoot>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default TaxDetails;